<div class="report-producer">
  <div class="controls-row">
    <!-- Banques -->
    <div class="control-group">
      <label>Banques</label>
      <div class="banks-select-wrapper">
        <button type="button" class="banks-toggle" (click)="toggleBanksDropdown()">
          {{ selectedBanksLabel() }} ▾
        </button>
        <div class="banks-dropdown dropdown-centered" *ngIf="showBanksDropdown">
          <label class="all-check">
            <input type="checkbox" [checked]="isAllSelected()"
              (change)="$event ? selectAllBanks($event.target.checked) : null">
            Tout sélectionner
          </label>
          <div class="bank-item" *ngFor="let b of banks">
            <label>
              <input type="checkbox" [checked]="isBankSelected(b.id)" (change)="toggleBank(b.id)">
              {{ b.name }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <!-- Période -->
    <div class="control-group">
      <label>Période (Du / Au)</label>
      <div class="date-range-wrapper">
        <div class="input-with-label">
          <span>Du</span>
          <input type="date" [(ngModel)]="startDate" class="sub-input" />
        </div>
        <div class="input-with-label">
          <span>Au</span>
          <input type="date" [(ngModel)]="endDate" class="sub-input" />
        </div>
      </div>
    </div>

    <!-- Dernier lot -->
    <div class="control-group check-group">
      <label class="checkbox-label highlight">
        <input type="checkbox" [(ngModel)]="isLastTransfer"> Dernier lot
      </label>
    </div>

    <!-- Mode Démo removed -->

    <div class="control-group action-btn">
      <button (click)="applyFilters()" [disabled]="loading" class="btn-filter">
        {{ loading ? 'chargement' : 'Filtrer' }}
      </button>
    </div>
  </div>

  <!-- Légende Statuts -->
  <div class="status-legend-bar">
    <div class="legend-item" *ngFor="let s of statusMapping; let i = index">
      <span class="badge" [style.background]="statusColors[i]">{{ s.short }}</span> : {{ s.full }}
    </div>
  </div>

  <!-- Graphiques Doughnuts -->
  <div class="charts-grid">
    <div class="chart-card">
      <h3><strong>Répartition des polices (Nombre)</strong></h3>
      <div class="canvas-container">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #countsCanvas
          (dblclick)="handleChartClick($event, 'counts')"></canvas>
      </div>
    </div>
    <div class="chart-card">
      <h3><strong>Répartition CA (Montant)</strong></h3>
      <div class="canvas-container">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #caCanvas (dblclick)="handleChartClick($event, 'ca')"></canvas>
      </div>
    </div>
  </div>

  <!-- Histogrammes de Comparaison -->
  <div class="charts-grid">
    <div class="chart-card">
      <h3><strong>Comparaison Polices / Banque par Statut</strong></h3>
      <div class="canvas-container-bar">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #compCountsCanvas
          (dblclick)="handleChartClick($event, 'compCounts')"></canvas>
      </div>
    </div>
    <div class="chart-card">
      <h3><strong>Comparaison CA / Banque par Statut</strong></h3>
      <div class="canvas-container-bar">
        <div *ngIf="chartsLoading" class="chart-loader">Chargement...</div>
        <div *ngIf="!chartsLoading && !hasData" class="no-data">{{ noDataMessage }}</div>
        <canvas *ngIf="!chartsLoading && hasData" #compCaCanvas
          (dblclick)="handleChartClick($event, 'compCa')"></canvas>
      </div>
    </div>
  </div>
</div>
